import React, { useState } from 'react'

export enum ModalFilterEntitiesEnum {
  WORKSPACE = 'WORKSPACE',
  GROUP = 'GROUP',
  DATE = 'DATE',
  PATHWAY = 'PATHWAY',
  CAMPAIGN = 'CAMPAIGN'
}

export type ModalFilterEntitiesControlContextType = {
  activeModal: ModalFilterEntitiesEnum | null
  showModal: (modal: ModalFilterEntitiesEnum | null) => void
  hide: () => void
}
export const ModalFilterEntitiesControlContext =
  React.createContext<ModalFilterEntitiesControlContextType>(
    null as unknown as ModalFilterEntitiesControlContextType
  )

export const EntityFilterModalControlProvider: React.FC = ({ children }) => {
  const [activeModal, setActiveModal] =
    useState<ModalFilterEntitiesEnum | null>(null)

  const hide = React.useCallback(() => {
    setActiveModal(null)
  }, [])

  const context = React.useMemo((): ModalFilterEntitiesControlContextType => {
    return {
      hide,
      showModal: setActiveModal,
      activeModal: activeModal
    }
  }, [activeModal])

  return (
    <ModalFilterEntitiesControlContext.Provider value={context}>
      {children}
    </ModalFilterEntitiesControlContext.Provider>
  )
}
